import React, { lazy } from 'react';
import { PageNotFound } from '@/layout/common-pages';
import ProtectedRoute from '@/router/components/ProtectedRoute';
import { ROUTES } from '@/constants/routes';

// Lazy loaded components
const ResourcePage = lazy(() => import('@/pages/resources'));
const ResourceDetails = lazy(
  () => import('@/pages/resources/resource-details/ResourceDetails'),
);

/**
 * Resource-related routes configuration
 */
export const resourceRoutes = {
  path: ROUTES.RESOURCE,
  element: <ProtectedRoute component={ResourcePage} />,
  children: [
    {
      path: ROUTES.RESOURCE_DETAILS,
      element: <ProtectedRoute component={ResourceDetails} />,
    },
    {
      path: ROUTES.RESOURCE_DETAILS_NO_DATA,
      element: <PageNotFound />,
    },
  ],
};
